import { Col } from 'react-styled-flexboxgrid'
import styled from 'styled-components'
export const StartCard = styled.div`
  width: 230px;
  height: 386px;
  background-color: #ccdcfc;
  border-radius: 12px;
  border: 2px solid #b2cafa;
  padding: 32px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const ScormContentWrapper = styled.div`
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const ScormTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #2b2f38;
  line-height: 1.3;
  margin-bottom: 12px;
  text-align: center;
  min-height: 50px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const ScormDescription = styled.div`
  color: #6b7280;
  font-size: 14px;
  width: 185px;
  min-height: 65px;
  line-height: 1.5;
  margin-bottom: 18px;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
  overflow-wrap: break-word;
`

export const StartLink = styled.div`
  font-size: 14px;
  color: #3b3f46;
  font-weight: 500;
  text-decoration: underline;
  text-underline-offset: 2px;
  text-decoration: underline;
  cursor: pointer;
  margin-bottom: 32px;
  gap: 6px;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
`

export const ScormButtonWrapper = styled.div`
  width: 100%;
  margin-top: auto;
  padding-bottom: 32px;
`

export const CompleteCard = styled.div`
  width: 230px;
  height: 386px;
  background-color: #ecfbf4;
  border-radius: 12px;
  border: 2px solid #a5d6a7;
  padding: 32px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ScoreDisplay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`

export const ScoreCircle = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: #4caf50;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
`

export const ScorePercentage = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: #2e7d32;
`

export const ProgressCard = styled.div`
  width: 230px;
  height: 386px;
  background-color: #ede7f6;
  border-radius: 12px;
  border: 2px solid #ded4ed;
  padding: 32px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ScromContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 0 8px 16px 8px;
  scroll-snap-type: x mandatory;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;
  align-items: stretch;
`

export const CardWrapper = styled.div`
  flex: 0 0 auto;
  scroll-snap-align: start;
`

export const EndSpacer = styled.div`
  flex: 0 0 24px;
`

export const Container = styled.div`
  padding: 16px;
  background-color: #f6f6f6;
`

export const ProgressLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 6px;
`

export const SoftContainer = styled.div`
  display: flex;
  align-items: center;
`

export const SoftProgressContainer = styled.div`
  flex: 1;
`

export const SoftCompletion = styled.div`
  background: white;
  padding: 8px;
  margin-left: 16px;
  margin-right: 8px;
  border-radius: 4px;
  text-align: center;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.3);
`

export const SoftScore = styled.div`
  font-size: 20px;
  font-weight: 500;
  text-align: center;
`

export const SoftScoreLabel = styled.div`
  font-size: 12px;
  line-height: 1.3;
  color: #6b7280;
`

export const StyledCollapseWrapper = styled.div`
  height: 24px;
  display: flex;
  align-items: center;
`

export const SoftSelectorWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  ${({ theme }) => `
    column-gap: ${theme.space.md};
    row-gap: ${theme.space.sm};
    margin-top: ${theme.space.sm};
    label {
      font-size: ${theme.fontSize.xxxs};
    }
  `}
`

export const SoftSelectorContainer = styled(Col)`
  padding: 0;
  .ant-select {
    width: 100%;
  }
`

export const HeaderActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
`

export const ChangeLanguageButton = styled.button`
  background: #004fef;
  color: #fff;
  border: none;
  padding: 6px 8px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`

export const ModalContent = styled.div`
  text-align: center;
  padding: 40px;
  width: 520px;
  max-width: 100%;
`

export const ModalTitle = styled.h3`
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.3;
`

export const SelectContainer = styled.div`
  position: relative;
  display: inline-block;
`

export const StyledSelect = styled.select`
  width: 260px;
  padding: 10px 15px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #ccc;
  background-color: #fff;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  outline: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  &:focus {
    border-color: #004fef;
  }
`

export const SelectChevron = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #666;
`

export const WarningText = styled.p`
  margin-top: 20px;
  font-size: 13px;
  color: #d93025;
  font-weight: 500;
  line-height: 1.4;
`

export const ConfirmButton = styled.button`
  margin-top: 20px;
  background: #004fef;
  color: #fff;
  border: none;
  padding: 10px 30px;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    background: #003dbb;
  }
`

export const InfoModalWrapper = styled.div`
  text-align: center;
  padding: 20px 15px 40px 15px;
  max-width: 250px;
  margin: 0 auto;
  h3 {
    margin-top: 0;
    margin-bottom: 15px;
  }
`

export const CardModalWrapper = styled.div`
  text-align: center;
  max-width: 250px;
  margin: 0 auto;
  h3 {
    margin-top: 0;
    margin-bottom: 15px;
  }
`

export const ModalDescription = styled.p`
  font-size: 13px;
  color: #3b3f46;
  margin: 12px 0 24px 0;
  line-height: 1.4;
  font-style: italic;
  text-align: center;
  #strong-text {
    font-weight: 800;
    font-style: italic;
  }
`

export const CardModalDescription = styled.p`
  font-size: 13px;
  color: #3b3f46;
  margin: 12px 0 24px 0;
  line-height: 1.4;
  text-align: center;
  strong {
    font-weight: 600;
  }
`

export const CloseLink = styled.span`
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
  color: #004fef;
  font-weight: 500;
  display: inline-block;
`

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 40px;
`

export const CancelButton = styled.button`
  padding: 8px 22px;
  border: 1px solid #004fef;
  background: white;
  color: #004fef;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: #f3f6ff;
  }
`

export const OkButton = styled.button`
  padding: 8px 28px;
  border: none;
  background: #004fef;
  color: white;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: #003bb5;
  }
`

export const AiTitleGroup = styled.div`
  display: inline-flex;
  margin-right: ${({ theme }) => theme.space.sm};
  align-items: center;
  vertical-align: middle;
  flex-wrap: wrap;
  row-gap: ${({ theme }) => theme.space.xs};
`

export const AiBadge = styled.span`
  min-width: ${({ theme }) => theme.layout.lg};
  margin-left: ${({ theme }) => theme.space.sm};
  color: #004fef;
  background-color: ${({ theme }) => theme.colors.brandPrimaryContrast};
  border-radius: 5px;
  font-size: ${({ theme }) => theme.fontSize.xxxs};
  margin-left: 56px;
  padding: 10px 18px;
  text-align: center;
`

export const CardModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

export const CardModalContainer = styled.div`
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  width: 250px;
  max-width: 90%;
  text-align: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
`

export const NoContentMessage = styled.p`
  text-align: center;
  background-color: #f6f6f6;
  font-size: 18px;
  min-height: 200px;
`
